// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"SocialAuthButton_buttonContainer__3gsx8","imageContainer":"SocialAuthButton_imageContainer__1xOBc","textContainer":"SocialAuthButton_textContainer__3Kf1j"};